import { render } from "./BottomLinks.vue?vue&type=template&id=109a9ee0"
import script from "./BottomLinks.vue?vue&type=script&lang=js"
export * from "./BottomLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__